import { useEffect, useRef } from 'react';
/**
 * usePrevious stores the previous state in a const. It's helpful for doing a comparison to avoid
 * an expensive operation like re-fetching or calculating. Use like:
 * ```
 * const [myVar, setMyVar] = useState<number>();
 * const prevMyVar = usePrevious(myVar);
 * ```
 * 
 * via https://blog.logrocket.com/accessing-previous-props-state-react-hooks/
 */
function usePrevious<T>(value: T) {
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = value; //assign the value of ref to the argument
  }, [value]); //this code will run when the value of 'value' changes
  return ref.current; //in the end, return the current ref value.
}
export default usePrevious;
